const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const resolveMediaUrl = (url) => {
  if (!url) {
    return '';
  }
  return url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
};
